const PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID;

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}

export function initPixel() {
  if (!PIXEL_ID) return;

  /* eslint-disable */
  (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  if (!PIXEL_ID) return;
  window.fbq('track', event, params);
}

export function trackPixelCustom(event: string, params?: Record<string, unknown>) {
  if (!PIXEL_ID) return;
  window.fbq('trackCustom', event, params);
}
